import * as React from "react";
import type { SVGProps } from "react";
const ArchitectureFirm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_4362_7493)">
      <path d="M13 10.9995v3.5h6v-3.5l-3-2.25z" />
      <path d="M24.0001 3.4995H8.858c-.447-1.72-1.999-3-3.858-3-2.206 0-4 1.794-4 4v15c0 2.206 1.794 4 4 4h19c.553 0 1-.447 1-1v-18c0-.553-.447-1-.9999-1m-17 12.537A3.97 3.97 0 0 0 5 15.4995c-.728 0-1.411.195-2 .537V4.4995c0-1.103.897-2 2-2s2 .897 2 2zm12.9299 3.463H18a.999.999 0 0 1-.9999-1A.999.999 0 0 1 18 17.4996h1.93c.552 0 1 .447 1 .9999 0 .553-.448 1-1 1m1.0701-4c0 .553-.447 1-1 1H12a.999.999 0 0 1-.9999-1v-5c0-.314.1479-.611.3999-.8l4-3a.999.999 0 0 1 1.2 0l4 3c.252.189.4.486.4.8z" />
    </g>
    <defs>
      <clipPath id="clip0_4362_7493">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default ArchitectureFirm;
